import { Button } from '@mui/material';
import { Box } from '@mui/system';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Link } from 'react-router-dom';
import { haveHasType, caravanType } from '../../../enumeration';
import { fDate, fDateApi } from '../../../utils/formatTime';
import Enum from '../enum';
import MoreTableItem from '../../../components/table/MoreTable/MoreTableItem';
import MoreTable from '../../../components/table/MoreTable/index';
import { separateNumberWithComma } from '../../../utils/index';

export const tableData = ({ baseRoute, queryString, disabled , onDelete }) => {
  const tableOptions = [
    {
      key: 'dispatch_date',
      header: 'تاریخ اعزام',
      Component: ({ param }) => param?.date || '-',
    },
    {
      header: 'استان',
      Component: ({ param }) => param?.province?.name || '-',
    },
    {
      header: 'جنسیت',
      Component: ({ param }) => param?.gender || '-',
    },
    {
      key: 'created_at',
      header: 'تاریخ ایجاد',
      Component: ({ param }) => fDate(param?.created_at) || '-',
    },
    // {
    //   key: 'actions',
    //   header: '',
    //   Component: ({ param }) => (
    //     <MoreTable>
    //       <Link to={`${baseRoute + Enum.routes.edit}/${param?.id}`}>
    //         <MoreTableItem isEdit />
    //       </Link>
    //       {/* <MoreTableItem isDelete onClick={() => onDelete(param)} /> */}
    //     </MoreTable>
    //   ),
    //   free: true,
    // },
    {
      key: 'show',
      header: '',
      Component: ({ param }) => (
        <Box
          sx={{
            display: 'flex',
            // gap: 3,
            alignItems: 'center',
          }}
        >
          {!disabled?.delete ? (
              <MoreTableItem isDelete disabled={{ label: true }} onClick={() => onDelete(param)}/>
          ) : (
            ''
          )}
          {!disabled?.update ? (
            <Link to={`${baseRoute + Enum.routes.edit}/${param?.id}`}>
              <MoreTableItem isEdit disabled={{ label: true }} />
            </Link>
          ) : (
            ''
          )}
        </Box>
      ),
      free: true,
    },
  ];
  // console.log({ AgentsInData });
  // if (AgentsInData?.length) {
  //   AgentsInData?.forEach((x) => {
  //     tableOptions.unshift({
  //       key: 'aa',
  //       header: x?.name,
  //       Component: ({ param }) => {
  //         // console.log('aaaaaaaa', { param }, param?.agents?.length);
  //         const dat = param?.agents?.find((y) => y?.agent?.id === x.id);
  //         return dat?.name || '-';
  //       },
  //     });
  //   });
  // }

  return tableOptions;
};
